const API_URL = {
  LOGIN: `/auth/signin`,
  REGISTER: `/auth/signup`,
  FORGOT_PASSWORD: `/auth/forgot-password`,
  RESET_PASSWORD: `/auth/reset-password`,
  CHECK_OTP: `/auth/check-otp`,
  LOGOUT: `/auth/logout`,
  CHANGE_PASSWORD: `/change-password`,
  UPDATE_PROFILE: `/update-profile`,
  // RESET_PASSWORD: (otp: string): string => `/${otp}/reset-password`,
  // COMMON: {
  //   SYNC: `/sync`,
  //   PRIVILEGES: `/privileges-list`,
  //   ROLES_LIST: (search: string): string =>
  //     `/roles-list${search ? `?search=${search}` : ''}`,
  // },
  SEND_MESSAGE: {
    CHECK: `/portability/add-check`,
    REQUEST: `/portability/add-request`,
    INQUIRY: `/portability/inquiry`,
    LIST: `/portability/list`,
    DELETE: `/portability/delete`,
    UPDATE: `/portability/update`,
    CANCEL: `/portability/cancel`,
    RETURN: `/portability/update-return-response`,
    UPDATE_EMAIL: `/portability/update-email`,
  },
  PROVIDER: {
    ADD: `/provider/add`,
    LIST: `/provider/list`,
    ACTIVE: `/provider/update-active-status`,
    DELETE: `/provider/delete`,
    UPDATE_EMAIL: `/provider/updateEmails`,
    LIST_WITH_CODE: `/provider/withCode`,
    REPORT: `/portability/get-report`,
    LIST_BY_CODES: `/provider/by/providerCodes`,
  },
  STAR_PROVIDER: {
    ADD: `/starProvider/add`,
    LIST: `/starProvider/list`,
    VIEW: `/starProvider/details`,
    EDIT: `/starProvider/update`,
    DELETE: `/starProvider/delete`,
  },
  NETWORK_PROVIDER: {
    ADD: `/networkProvider/add`,
    LIST: `/networkProvider/list`,
    VIEW: `/networkProvider/details`,
    EDIT: `/networkProvider/update`,
    DELETE: `/networkProvider/delete`,
  },
  NOC_PROVIDER: {
    ADD: `/nocProvider/add`,
    LIST: `/nocProvider/list`,
    VIEW: `/nocProvider/details`,
    EDIT: `/nocProvider/update`,
    DELETE: `/nocProvider/delete`,
  },
  SUPPORT_PROVIDER: {
    ADD: `/supportProvider/add`,
    LIST: `/supportProvider/list`,
    VIEW: `/supportProvider/details`,
    EDIT: `/supportProvider/update`,
    DELETE: `/supportProvider/delete`,
  },
  USER: {
    ME: `/user/me`,
    ADD: `/user/add`,
    LIST: `/user/list`,
    EDIT: `/user/edit`,
    DELETE: `/user/delete`,
    ACTIVE: `/user/update-active-status`,
  },
  REPORTS: {
    ADD: `/report/getreport`,
    LIST: `/report/reportList`,
    DELETE: `/report/deleteReport`,
  },
  PORTING_REPORTS: {
    ADD: `/reports/porting/getreport`,
    LIST: `/reports/porting/reportList`,
    DELETE: `/reports/porting/deleteReport`,
  },
  INTERNAL_REPORTS: {
    ADD: `/internal/getreport`,
    LIST: `/internal/reportList`,
    DELETE: `/internal/deleteReport`,
  },
  EXTERNAL_REPORTS: {
    ADD: `/external/getreport`,
    LIST: `/external/reportList`,
    DELETE: `/external/deleteReport`,
  },
  SOAP_REPORTS: {
    ADD: `/soap/getreport`,
    LIST: `/soap/reportList`,
    DELETE: `/soap/deleteReport`,
  },
  ASTERISK_NUMBER_BY_SHADOW_PREFIX_REPORTS: {
    ADD: `/asteriskNumberByShadowPrefixReport/getreport`,
    LIST: `/asteriskNumberByShadowPrefixReport/reportList`,
    DELETE: `/asteriskNumberByShadowPrefixReport/deleteReport`,
  },
  INTERNAL_PORTED_NUMBERS: {
    ADD: `/numberManagementInternalPortedNumbersReport/getreport`,
    LIST: `/numberManagementInternalPortedNumbersReport/reportList`,
    DELETE: `/numberManagementInternalPortedNumbersReport/deleteReport`,
  },
  PORTED_OUT_FROM_US_REPORT: {
    ADD: `/portedOutFromUsReportRouter/getreport`,
    LIST: `/portedOutFromUsReportRouter/reportList`,
    DELETE: `/portedOutFromUsReportRouter/deleteReport`,
  },
  NUMBER_ATTRIBUTES_REPORTS: {
    ADD: `/numberManagementNumberAttributesReport/getreport`,
    LIST: `/numberManagementNumberAttributesReport/reportList`,
    DELETE: `/numberManagementNumberAttributesReport/deleteReport`,
  },
  TOTAL_NUMBER__BY_ATTRIBUTES_REPORTS: {
    ADD: `/totalNumberByAttributesReports/getreport`,
    LIST: `/totalNumberByAttributesReports/reportList`,
    DELETE: `/totalNumberByAttributesReports/deleteReport`,
  },

  INQUIRE_NUMBER: {
    ADD: `/inquireNumber/inquiry`,
    LIST: `/inquireNumber/list`,
    DELETE: `/inquireNumber/delete`,
    REPORTS: `/inquireNumber/reports`,
  },
  PUBLISH: {
    ADD: `/publish/add`,
    LIST: `/publish/list`,
    REPORTS: `/publish/get-report`,
  },
  NUMBER_MANAGEMENT: {
    ADD: `/numberMange/add`,
    UPDATE: `/numberMange/update`,
    LIST: `/numberMange/list`,
  },
  NUMBER_ROUTING: {
    ADD: `/internalWhoise/add_routing_number`,
    UPDATE: `/internalWhoise/update_routing_number`,
    LIST: `/internalWhoise/get_internal_number`,
    BULK_INSERT_CSV_DATA: `/internalWhoise/bulkInsertCSV`,
  },
  INTERNAL_CODE: {
    ADD: `/internalCode/addCode`,
    UPDATE: `/internalCode/updateCode`,
    DELETE: `/internalCode/delete`,
    LIST: `/internalCode/list`,
  },
  ASTERISK: {
    ADD: `/add_start_fnr/add`,
    UPDATE: `/add_start_fnr/update`,
    CHECK: `/add_start_fnr/check`,
  },
  ASTERISK_NUMBER: {
    ADD: `/asterisk/add`,
    STATUS: `/asterisk/status`,
    DELETE: `/asterisk/delete`,
    LIST: `/asterisk/list`,
    VIEW_STATUS: `/asterisk/view-asterisk-status`,
    UPDATE_STATUS: `/asterisk/update-asterisk-status`,
  },
  SEND_EMAIL_SUPPORT: {
    LIST: `/emailSupport/list`,
    VIEW_STATUS: `/emailSupport/view-emailSupport-status`,
    DELETE: `/emailSupport/delete`,
    LOG_STATUS: `/emailSupport/log-history`,
    UPDATE_STATUS: `/emailSupport/update-emailSupport-status`,
    ALL_PROVIDERS: `/emailSupport/list-all-providers`,
  },
  ERROR_CODE: {
    ADD: `/response/addCode`,
    UPDATE: `/response/updateCode`,
    DELETE: `/response/deleteCode`,
    LIST: `/response/list`,
  },
  ADD_PORTABILITY_NUMBER: {
    ADD: `/portabilityNew/add`,
    LIST: `/portabilityNew/list`,
  },
  WEB_HOOK: {
    LIST: `/webhook/list`,
    DETAILS: `/webhook/details`,
    DELETE: `/webhook/delete`,
  },
  SIM_MANAGEMENT: {
    LIST: `/sim/list`,
    ADD: `/sim/add`,
    UPDATE: `/sim/update`,
    DETAILS: `/sim/details`,
    DELETE: `/sim/delete`,
    FIX_CSV_INSERT: `/sim/insert-csv`,
    EXPORT_FIELDS: `/sim/get-fields`,
    EXPORT_DATA: `/sim/export-csv`,
  },
  COMPANY_MENAGEMENT: {
    LIST: `/company_management/list`,
    DETAILS: `/company_management/details`,
    FIX_CSV_INSERT: `/company_management/insert-csv`,
    DELETE: `/company_management/delete`,
    EXPORT: `/company_management/fields`,
    EXPORT_DATA: `/company_management/export`,
  },
  COMPANY_NUMBER_MENAGEMENT: {
    LIST: `/company_number/list`,
    DETAILS: `/company_number/details`,
    FIX_CSV_INSERT: `/company_number/insert-csv`,
    DELETE: `/company_number/delete`,
    EXPORT: `/company_number/fields`,
    EXPORT_DATA: `/company_number/export`,
    COMPANIES: `/company_number/companies`,
  },
  DASHBOARD: {
    DAILY_REPORT: `/dashboard/get-daily-reports`,
  },
};

export default API_URL;
